<template>
  <div style="background: #000;height: 100vh" v-if="loading">

    <div style="width: 100%; height: 100% ; position: relative">
      <div class="score-head">
        <div class="score-logo" style="position: absolute; top: 20px;left: 50px">
          <div class="score-logo-box" style="padding:2px;background: #fff;border-radius: 100%;">
            <img src="../../assets/logo2.png" alt="" style="width: 60px;height: 60px;border-radius: 100%;">
          </div>
        </div>

        <div class="score-menu" style="position: absolute; top: 20px;right: 50px">
          <div class="score-menu-box">
            <a-icon type="menu" @click="drawerVisible = true" :style="{ fontSize: '26px'}"/>
          </div>
        </div>
        <div style="font-size: 26px;padding: 30px 0 45px">
          {{ row.saiqu_name }}{{ row.title }}
        </div>

        <div style="font-size: 20px;">{{ subjectRow.subject_name }}</div>
        <div style="font-size: 20px;">{{ subjectRow.mingcheng }}
          <a-popover title="运动员" trigger="click">
            <template slot="content">
              <div style="color:#999;max-width: 450px;word-break: normal">
                {{ subjectRow.yundongyuans }}
              </div>
            </template>
            <a-icon type="search"/>
          </a-popover>
        </div>

      </div>

      <div class="score-content flex-start">
        <div class="score-content-left">
          <div class="score-content-operate">
            <div class="score-li" v-for="(item, index) in caipan" :key="index">
              <div class="score-li-box">
                <div class="caipan-info" :class="item.status != 1 ? 'caipan-info-disabled' : ''"
                     @click="onScoreOperate(index + 1)">
                  <div class="caipan-name">
                    裁判{{ index + 1 }}({{ item.name }})
                  </div>

                  <div class="caipan-score">{{ subjectRow['score' + (index + 1)] }}</div>
                  <div class="caipan-comment">{{
                      subjectRow['comment' + (index + 1)] ?
                          subjectRow['comment'
                          + (index + 1)] : '暂无评语'
                    }}
                  </div>
                </div>

                <div class="caipan-button"
                     :class="item.status === 1 ? 'caipan-button-active flex-between' : 'caipan-button-disabled flex-center'">
                  <div class="caipan-button-li" v-if="item.status === 1">
                    <img src="../../assets/icon-score-prev.png" alt="">
                    <a-popconfirm title="确认让该裁判重打分数吗?"
                                  @confirm="onReSetScore(item, index)"
                                  okText="确定"
                                  cancelText="取消">
                      <div>重打</div>
                    </a-popconfirm>
                  </div>
                  <div class="caipan-button-li" v-if="item.status === 1">
                    <img src="../../assets/icon-score-logout.png" alt="">
                    <a-popconfirm title="确认让该裁判重新连接吗?"
                                  @confirm="onLoginOut(item, index)"
                                  okText="确定"
                                  cancelText="取消">
                      <div>下线</div>
                    </a-popconfirm>
                  </div>
                  <div class="caipan-button-li" @click="onScoreOperate(index + 1)">
                    <img src="../../assets/icon-score-edit.png" alt="">
                    <div>编辑</div>
                  </div>
                </div>

              </div>

            </div>

            <div class="score-li">
              <div class="score-li-box">
                <div class="caipan-info" @click="onScoreOperate('_add')">
                  <div class="caipan-name">加分</div>

                  <div class="caipan-score">{{ subjectRow['score_add'] }}</div>
                  <div class="caipan-comment">{{
                      subjectRow['comment_add'] ? subjectRow['comment_add']
                          :
                          '暂无评语'
                    }}
                  </div>
                </div>

                <div class="caipan-button caipan-button-score flex-center">
                  <div class="caipan-score-li" @click="onScoreOperate('_add')">
                    <img src="../../assets/icon-score-edit.png" alt="">
                    <div>编辑</div>
                  </div>
                </div>

              </div>

            </div>

            <div class="score-li">
              <div class="score-li-box">
                <div class="caipan-info" @click="onScoreOperate('_pen')">
                  <div class="caipan-name">减分</div>

                  <div class="caipan-score">{{ subjectRow['score_pen'] }}</div>
                  <div class="caipan-comment">{{
                      subjectRow['comment_pen'] ? subjectRow['comment_pen']
                          :
                          '暂无评语'
                    }}
                  </div>
                </div>

                <div class="caipan-button caipan-button-score flex-center">
                  <div class="caipan-score-li" @click="onScoreOperate('_pen')">
                    <img src="../../assets/icon-score-edit.png" alt="">
                    <div>编辑</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="score-content-right">
          <div class="content-right-head flex-between">
            <div class="right-head-li" :class="subjectRow.jgroup === 1 ? 'right-head-li-disabled' : ''">
              A组裁判{{ caipanListA.length > 0 ? parseInt(currentIndex) + 1 + '/' + scoreList.length : '0/0' }}
            </div>
            <div class="right-head-line"></div>
            <div class="right-head-li" :class="subjectRow.jgroup === 0 ? 'right-head-li-disabled' : ''">
              B组裁判{{ caipanListB.length > 0 ? parseInt(currentIndex) + 1 + '/' + scoreList.length : '0/0' }}
            </div>
          </div>

          <div class="content-right-body">
            <div class="right-body-top flex-between">
              <div>总得分</div>
              <!--              <a-button type="primary" @click="handleRank">查看排名{{-->
              <!--                  subjectRow.rank != '-' ? '（' +-->
              <!--                      subjectRow.rank + '）' : ''-->
              <!--                }}-->
              <!--              </a-button>-->
              <a-button type="primary" @click="handleRank">查看排名
              </a-button>
            </div>

            <div class="right-body-score">
              {{ subjectRow.score_total }}
            </div>
                        <div class="right-body-time">
                          <div class="right-body-time-one">
                            <div class="body-time-label">用时：</div>

                            <div class="body-time-value" v-if="!timeVisible">{{ sTime }}</div>
                            <a-icon type="edit" v-if="!timeVisible" @click="timeVisible = true"/>


                            <a-time-picker :default-open-value="moment(sTime, 'HH:mm:ss')"
                                           :value="moment(sTime, 'HH:mm:ss')"
                                           v-if="timeVisible"
                                           style="margin:8px 0;"
                                           @openChange="openChange"
                                           @change="onSaiTimeChange"/>
                            <a-button type="link" v-if="timeVisible" @click="timeVisible = false">取消</a-button>
                          </div>
                          <div class="right-body-time-rule flex-start" v-if="false">
                            <div class="time-rule-label">规定用时：</div>
                            <div class="time-rule-value">{{ row.sai_time_total }}</div>
                            <div style="margin-left: 10px"
                                 v-if="getTimeSecond(scoreList[currentIndex].stime) > getTimeSecond(row.sai_time_total)">
                              <a-tag color="#f50">超时</a-tag>
                            </div>
                          </div>

                          <div class="body-time-button flex-start">
                            <!--                                {{ scoreList[currentIndex].timeStatus}}-->
<!--                            <a-button type="primary" size="small"-->
<!--                                      @click="onTimeStart('continue')"-->
<!--                                      :disabled="!scoreList[currentIndex].timeStatus || scoreList[currentIndex].timeStatus === 'pause'? false: true"-->
<!--                                      v-if="getTimeSecond(scoreList[currentIndex].stime) > 0 ||-->
<!--                                                scoreList[currentIndex].timeStatus == 'pause'">-->
<!--                              继续计时-->
<!--                            </a-button>-->
<!--                            <a-button type="primary" size="small" @click="onTimeStart('start')" v-else>开始计时-->
<!--                            </a-button>-->
<!--                            <a-button type="primary" size="small"-->
<!--                                      :disabled="scoreList[currentIndex].timeStatus === 'start' || scoreList[currentIndex].timeStatus === 'continue'? false: true"-->
<!--                                      @click="onTimePause">-->
<!--                              停止计时-->
<!--                            </a-button>-->
<!--                            <a-button type="primary" size="small" @click="onTimeRestart"-->
<!--                                      :disabled="getTimeSecond(scoreList[currentIndex].stime) > 0 || scoreList[currentIndex].timeStatus === 'pause'? false: true">-->
<!--                              重新计时-->
<!--                            </a-button>-->

                            <a-button type="primary" size="small" class="button-one" disabled
                                      v-if="subjectRow.status==3">比赛弃权
                            </a-button>
                            <a-button type="primary" size="small" class="button-one"  @click="onSubjectStatusChange(1)"
                                      v-if="subjectRow.status==3">点击恢复
                            </a-button>
                            
                            <a-popconfirm title="确定弃权吗?" @confirm="onSubjectStatusChange(3)" okText="确定"
                                          cancelText="取消" v-if="subjectRow.status==1">
                              <a-button type="primary" size="small" class="button-one">
                                比赛弃权
                              </a-button>
                            </a-popconfirm>
                          </div>
                        </div>

          </div>



          <div class="content-right-foot content-right-foot-start" v-if="row.current_index==subjectRow.index||row.current_indexb==subjectRow.index">
            <a-popconfirm title="确认提交分数吗?" @confirm="onSubjectStatusChange(2)" okText="确定"
                          cancelText="取消" v-if="subjectRow.status == 1">
              <div class="content-right-foot content-right-foot-score">提交分数</div>
            </a-popconfirm>
            <div class="content-right-foot content-right-foot-started" v-else-if="subjectRow.status == 2">
              已完成
            </div>
            <div class="content-right-foot" v-else-if="subjectRow.status == 3">
              已弃权
            </div>
          </div>

          <div class="content-right-foot" v-else>
            <div class="content-right-foot-start" v-if="subjectRow.status == 3">已弃权</div>
            <div class="content-right-foot content-right-foot-started" v-else-if="subjectRow.status == 2">
              已完成
            </div>
            <div class="content-right-foot-un-start" @click="handleSetCurrent(currentIndex)" v-else>开始评分</div>
          </div>
        </div>

      </div>
      <div class="score-foot">
        <div class="foot-index">{{ parseInt(currentIndex) + 1 }} / {{ scoreList.length }}</div>
        <div class="foot-content flex-between">
          <img src="../../assets/icon-score-left-disabled.png" v-if="currentIndex === 0" alt="">
          <img src="../../assets/icon-score-left.png" v-else @click="onSubjectPrev">

          <div class="foot-li-box flex-start">
            <div :style="'width: ' + 100 / scoreList.length + '%'"
                 v-for="(item, index) in scoreList" :key="item.id">
              <div v-if="item.status == 2" class="foot-li foot-li-active"
                   :class="index == currentIndex ? 'foot-li-selected' : ''">{{ index + 1 }}
              </div>
              <div v-if="item.status == 3" class="foot-li foot-li-fail"
                   :class="index == currentIndex ? 'foot-li-selected' : ''">{{ index + 1 }}
              </div>
              <div :class="index == currentIndex ? 'foot-li-selected' : ''" v-if="item.status == 1" class="foot-li">
                {{ index + 1 }}
              </div>
            </div>
          </div>
          <img src="../../assets/icon-score-right-disabled.png" v-if="currentIndex === scoreList.length - 1"
               alt="">
          <img src="../../assets/icon-score-right.png" v-else @click="onSubjectNext" alt="">
        </div>
      </div>


<!--      <div style="color: #fff">subjectRow.status || {{subjectRow}}</div>-->
    </div>

    <a-drawer
        title="队伍信息"
        placement="right"
        width="360"
        :closable="false"
        :visible="drawerVisible"
        :get-container="false"
        :wrap-style="{ position: 'absolute' }"
        @close="drawerVisible = false"
    >
      <div class="army-box">
        <div class="army-li" :style="item.status == 2 ? 'background: #efefef ' : ''" v-for="(item, index) in scoreList"
             :key="item.id" @click="onSubjectCurrent(index)">
          <div class="army-li-left">
            <div class="army-name">【{{index + 1}}】队伍名称：{{ item.mingcheng }}</div>
            <div class="army-subject">项目名称：{{ item.subject_name }}</div>
            <!--            <div class="army-danwei">单位：{{item.danwei}}</div>-->
            <!--          <div class="army-yundongyuans">运动员：{{item.yundongyuans}}</div>-->
          </div>
          <div class="army-li-right" v-if="currentIndex == index">
            <a-icon type="check-circle" :style="{ fontSize: '22px'}" theme="twoTone" two-tone-color="#52c41a"/>
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal
        :maskClosable="false"
        title="操作"
        :width="600"
        :centered="true"
        v-model="scoreVisible"
        @cancel="scoreVisible = false"
    >
      <a-form :form="form">
        <a-form-item label="打分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-if="caipanIndex === '_add' || caipanIndex === '_pen'" v-model="scoreValue" @change="onScoreValueChange"  :min="0" 
                          placeholder="请输入分值" style="width: 300px"/>
          <a-input-number v-else v-model="scoreValue" @change="onScoreValueChange"  :min="0" :max="100"
                          placeholder="请输入分值" style="width: 300px"/>
        </a-form-item>
        <div v-if="caipanIndex === '_add' || caipanIndex === '_pen'">
          <a-form-item label="评语内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea v-model="scoreComment" placeholder="请输入评语内容" style="width: 300px"/>

            <div>
              <a-tag v-for="item in commentList" :key="item.id" @click="onCommentSelect(item.content)">
                {{ item.content }}
              </a-tag>
            </div>

          </a-form-item>
        </div>

      </a-form>
      <template slot="footer">
        <a-button key="cancel" @click="scoreVisible = false">取消</a-button>
        <a-button key="forward" type="primary" @click="onScoreSave">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="积分排名"
        :width="800"
        :centered="true"
        :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
        v-model="rankVisible"
        @cancel="rankVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form"  layout="inline">
          <a-row style="padding-bottom: 24px;">
            <a-col>

              <a-form-item
                  label="项目筛选"
                  hasFeedback
                  class="flex-start"
              >
                <a-cascader @change="onSubjectChange" :options="subjectOptions"
                            style="width: 400px"
                            :fieldNames="{ label: 'name', value: 'key', children: 'children' }"
                            placeholder="请选择项目" v-model="subjectQuery" changeOnSelect
                />

              </a-form-item>

              <a-form-item label="类型">  
                <a-select v-model="queryParam.type"  >
                  <a-select-option :value="1">决赛</a-select-option>
                  <a-select-option :value="2">预赛</a-select-option> 
                </a-select>
              </a-form-item>

              <a-form-item>
                <a-button type="primary" @click="onSubjectSearch">查询</a-button>
              </a-form-item>

            </a-col>
          </a-row>

          <a-table :columns="scoreColumns" :dataSource="scoreRankList" :pagination="false" rowKey="id"
                   bordered>
                        <span slot="mingcheng" slot-scope="name,record,index">
                             {{ index + 1 }}# {{ record.mingcheng }}  <br/>
                               <span style="color:#999">{{ record.subject_name }}</span><br/>
              </span>
            <span slot="mingci" slot-scope="text,record,index">
                            <span v-if="record.rank_value == '-'">-</span>
                            <span v-else>第{{ record.rank_value }}名</span>
                        </span>

            <span slot="action" slot-scope="text,record">
                            <template>
                              <a @click="handleEdit(record)">编辑</a>
                            </template>
                          </span>
          </a-table>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button style="margin-left: 8px" @click="createRankBook">生成项目排名表</a-button>
        <a-button @click="download(1)" style="margin-left: 8px">
          成绩单下载
          <a-icon type="download"/>
        </a-button>
        <a-button key="cancel" @click="rankVisible = false">取消</a-button>
        <a-button key="forward" type="primary" @click="rankVisible = false">确定</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="订正数据"
        :width="1200"
        :centered="true"
        :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
        v-model="dataVisible"
        @cancel="dataVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <div style="margin-bottom: 10px">
            {{ dataRow.mingcheng }} <br/>
            <span style="color:#999">{{ dataRow.subject_name }}</span><br/>
          </div>
          <a-table :columns="dataColumns" :dataSource="[dataRow]" :pagination="false" rowKey="id"
                   bordered>
                        <span slot="dataCaipan1" slot-scope="text,record,index">
                            <editable-cell :text="record['score1']" @change="onDataChange(record, 1, $event)"/>
                        </span>
            <span slot="dataCaipan2" slot-scope="text,record,index">
                            <editable-cell :text="record['score2']" @change="onDataChange(record, 2, $event)"/>
                        </span>
            <span slot="dataCaipan3" slot-scope="text,record,index">
                            <editable-cell :text="record['score3']" @change="onDataChange(record, 3, $event)"/>
                        </span>
            <span slot="dataCaipan4" slot-scope="text,record,index">
                            <editable-cell :text="record['score4']" @change="onDataChange(record, 4, $event)"/>
                        </span>
            <span slot="dataCaipan5" slot-scope="text,record,index">
                            <editable-cell :text="record['score5']" @change="onDataChange(record, 5, $event)"/>
                        </span>
            <span slot="dataCaipan6" slot-scope="text,record,index">
                            <editable-cell :text="record['score6']" @change="onDataChange(record, 6, $event)"/>
                        </span>
            <span slot="dataCaipan7" slot-scope="text,record,index">
                            <editable-cell :text="record['score7']" @change="onDataChange(record, 7, $event)"/>
                        </span>
            <span slot="dataCaipan8" slot-scope="text,record,index">
                            <editable-cell :text="record['score8']" @change="onDataChange(record, 8, $event)"/>
                        </span>
            <span slot="dataCaipan9" slot-scope="text,record,index">
                            <editable-cell :text="record['score9']" @change="onDataChange(record, 9, $event)"/>
                        </span>
            <span slot="dataCaipan10" slot-scope="text,record,index">
                            <editable-cell :text="record['score10']" @change="onDataChange(record, 10, $event)"/>
                        </span>
            <span slot="dataCaipanAdd" slot-scope="text,record,index">
                            <editable-cell :text="record['score_add']" @change="onDataChange(record, '_add', $event)"/>
                        </span>
            <span slot="dataCaipanPen" slot-scope="text,record,index">
                            <editable-cell :text="record['score_pen']" @change="onDataChange(record, '_pen', $event)"/>
                        </span>
          </a-table>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="dataVisible = false">取消</a-button>
        <a-button key="forward" type="primary" @click="dataVisible = false">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<style>
body {
  overflow-y: hidden;
}

.army-li {
  padding: 10px 0;
  border-bottom: 1px solid #efefef;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.score-foot {
  margin: 0px 30px 0;
}

.score-foot img {
  width: 20px;
  cursor: pointer;
}

.foot-index {
  color: #aaa;
  margin-bottom: 10px;
  text-align: center;
}

.foot-li-box {
  width: 92%;
}

.foot-li {
  height: 40px;
  border: 1px solid #4A4A4A;
  text-align: center;
  line-height: 40px;
  color: #666;
  font-size: 16px;
}

.foot-li-active {
  background: #1F85E2;
}

.foot-li-fail {
  background: #FF4D50;
}

.foot-li-selected {
  border: 1px solid #fff;
}

.score-content-right {
  width: 25%;
  background: #333333;
  border-radius: 10px;
  color: #fff;
  overflow: hidden;
  position: relative;
}

.content-right-head {
  padding: 20px 15px 10px;
  border-bottom: 1px dashed #aaa;
  font-size: 16px;
}

.right-head-li {
  width: 50%;
  text-align: center;
}

.right-head-li-disabled {
  color: #666;
}

.content-right-body {
  padding-top: 15px;
}

.right-body-top {
  padding: 0 20px;
}

.right-body-score {
  font-size: 120px;
  padding-left: 15px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
}

.right-body-time {
  padding-left: 20px;
}

.right-body-time-one {
  display: flex;
  align-items: center;
}

.right-head-line {
  width: 1px;
  height: 15px;
  background: #aaa;
}

.right-body-time-rule button {
  margin-left: 10px;
}

.body-time-value {
  font-size: 30px;
  font-family: Helvetica;
  color: #FFFFFF;
}

.time-rule-value {
  font-size: 18px;
  font-family: Helvetica;
  color: #D0021B;
}

.body-time-button {
  margin-top: 5px;
}

.body-time-button button {
  margin-right: 10px;
}

.content-right-foot {
  position: absolute;
  bottom: 0;
  height: 60px;
  line-height: 60px;
  width: 100%;
  text-align: center;
  font-size: 22px;
}

.content-right-foot-un-start {
  background: #1F85E2;
  cursor: pointer;
}

.content-right-foot-started {
  background: #0EB791;
}

.content-right-foot-start {
  background: #4A4A4A;
}

.content-right-foot-score {
  background: #FF4D50;
}

.score-head {
  background: url("../../assets/icon-score-bg.png") no-repeat;
  background-size: 100% 205px;
  height: 205px;
  text-align: center;
  color: #fff;
  font-weight: 500;
}

.score-content {
  margin: 30px 30px 0;
}

.score-content-left {
  width: 75%;
}

.score-content-operate {
  display: flex;
  flex-wrap: wrap;
}

.score-li {
  width: 20%;
  text-align: center;
}

.score-li-box {
  margin: 0 10px 10px 0;
  background: #fff;
  overflow: hidden;
  border-radius: 10px;
}

.caipan-info {
  padding: 10px 0;
  cursor: pointer;
}

.caipan-info-disabled {
  background: #EEEEEE;
}

.caipan-name {
  font-weight: 500;
  color: #4A4A4A;
}

.caipan-score {
  font-size: 30px;
  font-weight: 500;
  color: #000;
  font-family: DINAlternate-Bold, DINAlternate;
}

.caipan-comment {
  color: #9B9B9B;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caipan-button {
  padding: 0 5px;
  height: 35px;
  width: 100%;
}

.caipan-button-active {
  background: #1F85E2;
}

.caipan-button-score {
  background: #0EB791;
  cursor: pointer;
}

.caipan-button-disabled {
  background: #9B9B9B;
}

.caipan-button-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  height: 35px;
  cursor: pointer;
  color: #fff;
}

.caipan-score-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  color: #fff;
  height: 35px;
  cursor: pointer;
}

.caipan-button-li img, .caipan-score-li img {
  width: 14px;
  margin-right: 5px;
}

</style>
<script>
import qs from 'qs'
import {
  getScoreList,
  getScoreRankList,
  setScore,
  setTime,
  setSubjectStatus,
  setCurrent,
  scoreCommentOptions,
  setCaipanStatus, zhixuceCreate, zhixuceDownload, createRankBook
} from '@/api/dscore'
import {sjsqOptions, subjectOptions} from '@/api/sai'
import EditableCell from '@/components/EditableCell/'
import Vue from 'vue'
import moment from 'moment'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import setting from "../../config/setting";

export default {
  name: 'ScoreForm',
  components: {
    EditableCell
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      // tableHeight:document.documentElement.clientHeight-180,
      // tableHeight:300,
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperColNew: {
        xs: {span: 24},
        sm: {span: 12},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      form: this.$form.createForm(this),
      row: {
        current_index: 0,
        caipan_type_num: 1,
        sai_time_total: '00:00:00', //比赛用时
        is_admin: true
      },
      list: [{}],
      commentList: [],
      defaultCaipanList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], //默认裁判数量
      caipan: [],
      caipanListA: [],
      caipanListB: [],

      caipanAdmin: {}, // 裁判长信息
      scoreList: [{stime: ''}],
      formData: {
        id: 0
      },

      subjectOptions: [],
      subjectQuery: [],

      currentIndex: -1, //当前队伍
      currentSubjectIndex: -1, //当前比赛队伍
      scoreRankList: [], //项目排名

      // 单只项目队伍信息
      subjectRow: {
        id: 0,
        rank: 0,
        score_total: '0.0', // 总得分
        jgroup: '',
        subject_name: 'xx',
        mingcheng: 'xx',
        timeStatus: ''
      },

      isContinue: false,
      timeVisible: false,
      sTime: '00:00:00', //比赛用时字符串
      socket: '',

      status: '', // pause
      timerList: [],
      timeTotal: 0,
      timeString: 0,
      scoreValue: '', //分值
      scoreComment: '', // 减分评语
      scoreCommentId: '', // 减分评语id
      caipanIndex: 0, //操作的裁判

      dataId: 0,
      dataRow: {},

      queryParam: {
        keywords: '',
        type:1,
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },

      columns: [
        {
          title: 'Name',
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'},
        },
      ],
      // 积分排名表头
      scoreColumns: [
        {
          title: '队伍信息',
          dataIndex: 'mingcheng',
          scopedSlots: {customRender: 'mingcheng'},
          width: 600,
        },
        {
          title: '总得分',
          dataIndex: 'score_total',
          width: 120,

        },
        {
          title: '名次',
          dataIndex: 'mingci',
          width: 120,
          scopedSlots: {customRender: 'mingci'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          scopedSlots: {customRender: 'action'},
        },
      ],

      // 订正数据表头
      dataColumns: [],

      timer: null
    }

  },
  mounted() {
    const that = this
    let id = that.formData.id = that.$route.query.id

    // 开始socket
    // that.init()

    // 获取数据
    that.fetch()

    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 4000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  computed: {},
  methods: {
    moment,
    fetch() {
      //刷新数据
      const that = this

      getScoreList({
        id: that.formData.id
      }).then(res => {
        // 获取开始 比赛的队伍
        res.data.list.map(row => {
          if (that.currentIndex == -1) {
            if (row.current) {
              that.currentIndex = that.currentSubjectIndex = row.index
            }
          }
        })

        that.loading = true
        // 格式化数据
        that.formatData(res.data)
      }).catch(err => {
        that.$message.error(err.data.msg)
      })
    },

    // 格式化数据
    formatData(data) {
      const that = this
      that.scoreList = data.list
      that.row = data.row

      that.queryParam.sjsq = [1, data.row.saiqu]

      // 定义 比赛总时间规则
      that.row.sai_time_total = data.row.sai_time_total ? data.row.sai_time_total : '00:00:00'
      that.caipan = data.caipan

      data.caipan.map(row => {
        if (row.type == '裁判') {
          if (row.jgroup == 0) {
            that.caipanListA.push(row)
          } else {
            that.caipanListB.push(row)
          }
        }

        if (row.type == '裁判长') {
          that.caipanAdmin = row
        }

      })

      // 获取参赛队伍 信息
      that.getSubjectRow()
      // console.log(that.caipanListA, that.caipanListB)
    },

    // 获取单只队伍详情
    getSubjectRow() {
      let that = this,
          index = that.currentIndex,
          list = that.scoreRankList,
          caipanList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          rank = 0, //名次
          subjectRow = that.subjectRow = that.scoreList[index],
          caipan = !subjectRow.jgroup || subjectRow.jgroup == 0 ? that.caipanListA : that.caipanListB

      that.sTime = subjectRow.stime

      list.map((row) => {
        if (row.id == that.subjectRow.id) {
          rank = row.rank_value
        }
      })
      that.subjectRow.rank = rank

      // console.log('scoreList22', caipan,that.caipanListA, that.caipanListB)

      // 根据index 设置裁判位置
      // vue的双向绑定导致 defaultCaipanList值发生变化 循环时重置为预设的10个裁判位
      caipanList.map((item, scoreIndex) => {
        caipan.map((row) => {
          if (scoreIndex == row.index) {
            caipanList[scoreIndex] = row ? row : ''
          }
        })
      })

      // 运行的timer丢失
      that.getListTimer()

      that.caipan = caipanList
      console.log("getSubjectRow", that.subjectRow, caipanList, that.scoreList)

      // 获取排名信息
      // that.getRankList(that.subjectRow.subject)

      that.drawerVisible = false
    },

    getRankList(subject) {
      let that = this

      that.queryParam.subjectRow = subject
      getScoreRankList({
        id: that.formData.id,
        type:that.queryParam.type,
        subject: subject
      }).then(res => {
        that.scoreRankList = res.data.list
        that.row.sai_time_total = res.data.time_total


        // 需要是数组
        let arr = subject.split('.'),
            data = []

        arr.map((row, index) => {
          let dataRow = ''
          for (var i = 0; i <= index; i++) {
            dataRow += arr[i] + '.'
          }

          dataRow = dataRow.substr(0, dataRow.length - 1)
          data.push(dataRow)
        })

        console.log(subject, arr, data)
        that.subjectQuery = data

        // that.subjectQuery = ['CLUB2021FENZHANSAI11','CLUB2021FENZHANSAI11.1','CLUB2021FENZHANSAI11.1.1' ,'CLUB2021FENZHANSAI11.1.1.7']
      }).catch(err => {
        that.$message.error(err.data.msg)
      })
    },

    createRankBook() {
      let that = this;
      let query = {}
      query.sjsq = that.queryParam.sjsq
      query.type = that.queryParam.type
      query.subjects = [that.queryParam.subjectRow]
      createRankBook(query).then(res => {
        that.$message.success('生成成功')
      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    download(type) {
      let that = this;
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/dscore/rankListDownload?' + qs.stringify(that.queryParam));
          break;
      }
    },

    handleEdit(record) {

      console.log("handleEdit", record)
      this.dataRow = record
      this.dataVisible = true

      /**
       * {
            title: '操作',
            dataIndex: 'action',
            width: 120,
            scopedSlots: {customRender: 'action'},
          },
       */
      let data = []
      for (var i = 1; i <= 12; i++) {
        let row = {}

        if (i == 11) {
          row.title = '加分'
          row.scopedSlots = {customRender: 'dataCaipanAdd'}
        } else if (i == 12) {
          row.title = '减分'
          row.scopedSlots = {customRender: 'dataCaipanPen'}
        } else {
          row.title = '裁判' + i
          row.scopedSlots = {customRender: 'dataCaipan' + i}
        }

        row.dataIndex = i

        data.push(row)
      }
      console.log(data)
      this.dataColumns = data
    },

    getListTimer() {
      const that = this,
          list = that.timerList

      console.log('getListTimer', list)
      that.scoreList.map((score, scoreIndex) => {
        list.map(row => {
          if (scoreIndex === row.index) {
            score.timer = row.timer
            score.timeStatus = row.timeStatus
          }
        })
      })

    },

    // 开始计时
    onTimeStart(status = 'start') {
      const that = this,
          index = that.currentIndex,
          list = that.scoreList,
          row = list[index]

      row.timeStatus = status


      let timeTotal = that.getTimeSecond(list[index].stime)

      timeTotal += 1
      const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
          endTime = timeTotal * 1000 + today,
          date = that.formatDate(endTime, 'h:m:s')

      that.scoreList[index].stime = that.sTime = that.timeString = date
      that.timeTotal = timeTotal
      that.onTimeConfirm()

      if (status === 'pause') {
        return
      }


      // timer fetch的定义
      var timer = row.timer = setInterval(function () {
        console.log('onTimerActive')

        timeTotal += 1

        const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
            endTime = timeTotal * 1000 + today,
            date = that.formatDate(endTime, 'h:m:s')

        that.scoreList[index].stime = that.sTime = that.timeString = date
        that.timeTotal = timeTotal

        that.onTimeConfirm()
      }, 1000)

      const timeRow = {
        index: index,
        timer: timer,
        timeStatus: status
      }
      that.timerList.push(timeRow)
    },

    onTimePause(status = 'pause') {
      const that = this,
          index = that.currentIndex,
          list = that.scoreList,
          row = list[index]


      clearInterval(row.timer)

      this.onTimeStart('pause')


      // that.isContinue = true
      // clearInterval(row.timer)
    },

    onTimeRestart() {
      let that = this,
          index = that.currentIndex,
          list = that.scoreList

      //  找不到timer 问题
      clearInterval(list[index].timer)
      list[index].stime = '00:00:00'
      this.onTimeStart()
    },

    onTimeConfirm() {
      // todo 不要从服务端获取时间
      let that = this,
          index = that.currentIndex,
          list = that.scoreList

      that.sTime = list[index].stime
      this.openChange()
    },

    // 时间选择器状态改变 关闭时改变数据
    openChange(open) {
      const that = this

      console.log('openChange')

      if (open) return

      setTime({
        id: that.subjectRow.id,
        time: that.sTime
      }).then(res => {
        // that.$message.success('设置成功');
        that.timeVisible = false
        that.subjectRow.stime = that.sTime
        // that.fetch()

      }).catch(err => {
        console.log('--错误--');
        that.$message.error(err.data.msg);
      })
    },

    // 设置比赛时间
    onSaiTimeChange(time, timeString) {
      const that = this
      that.sTime = timeString ? timeString : '00:00:00'

      // console.log("onSaiTimeChange", time, timeString, that.sTime)
    },

    // 选择评语
    onCommentSelect(content) {
      this.scoreComment = content
    },

    // 开始比赛
    handleSetCurrent(current_index) {
      const that = this

      that.scoreList.map(item => {
        if(that.subjectRow.jgroup ==item.jgroup ){
          //同组别
          item.current = false
        }
      })
      that.currentIndex = current_index
      that.scoreList[current_index].current = true
      if(that.subjectRow.jgroup==0){
        that.row.current_index = current_index;
      }else{
        that.row.current_indexb = current_index;
      }
      console.log('thissubject',that.scoreList[current_index]);
      // return ;
      setCurrent({
        id: that.formData.id,
        current_index: current_index,
        jgroup:that.scoreList[current_index].jgroup
      }).then(res => {
        // 通知所有普通裁判
        let data = {
          id: that.formData.id
        }
        // let val = that.formatSocketInfo('sai_start', '', data)
        // this.socket.send(val)

        // tha
        that.drawerVisible = false
        that.$message.success('开始比赛')
        that.currentIndex = that.currentSubjectIndex = res.data.current_index;

      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    handleRank() {
      let that = this
      that.rankVisible = true
      that.queryParam.type = that.subjectRow.type
      that.getSubjectOptions()
    },


    getSubjectOptions() {
      let that = this;
      subjectOptions({saiqu: that.row.saiqu}).then(res => {
        that.subjectOptions = res.data
      });
      that.getRankList(that.subjectRow.subject)
    },

    // 查询排名
    onSubjectChange(value) {
      let endValue = this.subjectFilterValue = value[value.length - 1],
          list = this.mingdanOldLeftList

      console.log('onSubjectChange', value, endValue, list)
      // this.getRankList(endValue)
    },

    onSubjectSearch() {
      let endValue = this.subjectFilterValue
      if(!endValue) endValue = this.subjectRow.subject

      console.log('endValue',endValue)
      this.getRankList(endValue)
    },

    onScoreValueChange(value) {
      console.log("onScoreValueChange", value)
    },

    // 操作分数
    onScoreOperate(index) {
      const that = this
      that.caipanIndex = index
      that.scoreVisible = true

      console.log("onScoreOperate", index, that.scoreValue)

      that.scoreValue = that.scoreList[that.currentIndex]['score' + that.caipanIndex]
      that.scoreComment = that.scoreList[that.currentIndex]['comment' + that.caipanIndex]
      console.log('onScoreOperate')
      that.getCommentList()
    },

    getCommentList() {
      let that = this
      console.log("getCommentList")
      scoreCommentOptions().then(res => {
        that.commentList = res.data
      }).catch(err => {
        console.log('--错误--');
      })
    },

    // 重新设置分数
    onResetScoreChange(record, score_index, value, content = '') {
      console.log('score'.score_index);
      let that = this
      record['score' + score_index] = value
      setScore({
        id: record.id,
        score_index: score_index,
        score: value,
        content: content
      }).then(res => {
        that.$message.success('设置成功')
        that.scoreVisible = false

      }).catch(err => {
        console.log('--错误--');
        record['score' + err.data.data.score_index] = err.data.data.score;
        that.$message.error(err.data.msg);
      })
    },

    onDataChange(record, index, value) {
      let that = this
      console.log(record['score' + index])
      that.onScoreChange(record, index, value, record['comment' + index])
    },

    // 打分
    onScoreChange(record, score_index, value, content = '') {
      console.log('score'.score_index, record);

      let that = this
      record['score' + score_index] = value
      setScore({
        id: record.id,
        score_index: score_index,
        score: value,
        content: content
      }).then(res => {
        that.$message.success('打分成功')
        that.scoreVisible = false

        that.fetch()
      }).catch(err => {
        console.log('--错误--');
        record['score' + err.data.data.score_index] = err.data.data.score;
        that.$message.error(err.data.msg);
      })
    },

    // 存储分数
    onScoreSave() {
      let that = this,
          scoreValue = that.scoreValue,
          record = that.scoreList[that.currentIndex],
          scoreComment = that.scoreComment

      console.log(record, that.currentIndex, that.currentSubjectIndex)

      if (record.status === 2) {
        this.$message.error('当前队伍比赛已完成')
        return
      } else if (record.index != that.currentSubjectIndex) {
        // this.$message.error('当前队伍尚未开始比赛')
        // return
      }

      scoreValue = scoreValue == undefined ? 0 : scoreValue
      that.onScoreChange(record, that.caipanIndex, scoreValue, scoreComment)
    },

    // 切换下一支队伍
    onSubjectNext() {
      let that = this,
          index = that.currentIndex
      that.currentIndex = parseInt(index) + 1

      that.getSubjectRow()
    },

    // 切换指定队伍
    onSubjectCurrent(index) {
      let that = this
      that.currentIndex = index

      that.getSubjectRow()
    },

    // 切换上一支队伍
    onSubjectPrev() {
      let that = this,
          index = that.currentIndex
      that.currentIndex = index - 1

      that.getSubjectRow()
    },
    submitForm() {
    },

    //比赛弃权
    onSubjectStatusChange(status) {
      let that = this

      setSubjectStatus({
        id: that.subjectRow.id,
        status: status
      }).then(res => {
        that.$message.success('操作成功');

        // 刷新当前状态
        that.fetch()

        // let type = 'score_submit'
        // if (status === 3) type = 'sai_giveup'
        //
        // let data = {
        //   'id': that.row.id
        // }
        // let val = that.formatSocketInfo(type, '', data)
        //
        // that.socket.send(val)
      }).catch(err => {
        console.log('--错误--');
        that.$message.error(err.data.msg);
      })
    },

    // 重新打分
    onReSetScore(record, indexOld) {
      // 通知所有裁判 将分数置为0
      // console.log(record)
      let that = this,
          index = indexOld + 1
      this.onResetScoreChange(that.scoreList[that.currentIndex], index, 0, that.scoreList[that.currentIndex]['comment' + index])

      // let data = {}
      // let val = that.formatSocketInfo('score_reset', record.num, data)
      // this.socket.send(val)
    },

    // 手动下线
    onLoginOut(record) {
      // console.log(record)
      // 更改状态 通知客户端
      let that = this

      // 兼容客户端直接退出的情况
      setCaipanStatus({
        id: that.row.id,
        num: record.num
      }).then(res => {
        let data = {
          'id': that.row.id
        }

        that.fetch()

        // let val = that.formatSocketInfo('caipan_logout', record.num, data)
        // that.socket.send(val)

      }).catch(err => {
        console.log('--错误--');
      })
    },

    // 超时自动下线
    onLoginOutAuto(record) {
      // console.log(record)
      // 更改状态 通知客户端
      let that = this

      // 兼容客户端直接退出的情况
      setCaipanStatus({
        id: that.row.id,
        num: record.num
      }).then(res => {
        that.fetch()
      }).catch(err => {
        console.log('--错误--');
      })
    },

    init: function () {
      if (typeof (WebSocket) === "undefined") {
        alert("您的浏览器不支持socket")
      } else {
        // 实例化socket
        let that = this
        this.socket = new WebSocket(setting.wsBaseURL)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage

        this.socket.onclose = function (e) {
          // that.reconnect()
          console.log('websocket 断开：' + e.code + ' ' + e.reason + ' ' + e.wasClean)
        }
      }
    },
    open: function () {
      // console.log('heartStart',this.row)
      this.heartStart()
      this.heartCheck()
    },
    error: function () {
      console.log("连接错误")
      // this.reconnect()
    },
    getMessage: function (msg) {
      // console.log('getMessage', msg.data)
      let data = JSON.parse(msg.data),
          that = this


      // 判断在数组中
      let typeList = ['caipan_login', 'caipan_logout', 'score_submit', 'time_update']

      console.log('typeList.includes(data.type)', typeList.includes(data.type), data)
      if (typeList.includes(data.type) && that.formData.id == data.data.id) {
        that.fetch()
      }

      return;

      switch (data.type) {

          /**
           * caipan_login  名称：裁判登录， 刷新对象：裁判长
           * caipan_logout 名称：裁判退出， 刷新对象：裁判长刷新
           * score_submit  名称：裁判提交分数 刷新对象：裁判长刷新
           * time_update ，名称：时间更新 刷新对象：裁判长刷新
           *
           * score_reset ，名称：普通裁判重新打分 刷新对象：指定的普通裁判刷新
           * sai_start  名称：开始评分， 刷新对象：普通裁判
           * sai_complete 名称：评分完成， 刷新对象：仲裁
           * sai_giveup 名称：弃权， 刷新对象：仲裁
           */


        case 'caipan_common' :
          // 普通裁判登录 打分等
          //  if(id=='') 当前场次
          this.fetch()
          break
        case 'caipan_common_logout' :
          // 普通裁判下线 执行状态更改
          this.onLoginOutAuto(data) //delete
          break
        default:
          console.log('default')
      }
    },
    send: function (params) {
      this.socket.send(params)
    },
    close: function () {
      console.log("socket已经关闭")
    },

    heartStart() {
      let that = this

      let token = that.caipanAdmin.num,
          data = {
          }

      let val = that.formatSocketInfo('heart_start', token, data)
      that.socket.send(val)
    },

    heartCheck() {
      let that = this;
      that.heartTimer = setInterval(function () {

        let token = that.caipanAdmin.num,
            data = {
              'id': that.formData.id
            }

        let val = that.formatSocketInfo('heart_check', token, data)
        that.socket.send(val)
      }, 8000)
    },

    formatSocketInfo(type, token, data) {
      return JSON.stringify({
        'type': type,
        'token': token,
        'data': data,
      })

    },

    reconnect() {
      let that = this,
          lockReconnect = that.lockReconnect,
          tt = that.timer

      // 重连
      if (lockReconnect) return
      lockReconnect = true
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt)
      that.timer = setTimeout(function () {
        that.init()
        lockReconnect = false
      }, 4000)

    },

    getTimeSecond(time) {
      if (!time) {
        return '00:00:00'
      }
      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(sec)

      // console.log(hour, min, sec, Number(min * 60), Number(sec * 60))

      // console.log(time+ '-----' + s)
      return s
    },

    // 格式化为时间字符串
    // minute 添加的时间
    formatTimeToTime(time, minute = 0) {
      // let time = '03:58:00',
      //     minute = 3,
      let date = '',
          today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()

      // 如何得到 03:33:00

      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(minute * 60) + Number(sec)

      let endTime = s * 1000 + today

      date = this.formatDate(endTime, 'h:m:s')
      // console.log('formatTimeToTime', min,endTime, date)

      return date
    },

    formatDate(num, format) {
      const formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
      const returnArr = [];
      const date = new Date(num);
      returnArr.push(date.getFullYear()); // 取得4位数的年份
      returnArr.push(this.formatNumber(date.getMonth() + 1)); // 取得日期中的月份，其中0表示1月，11表示12月
      returnArr.push(this.formatNumber(date.getDate())); // 返回日期月份中的天数（1到31）
      returnArr.push(this.formatNumber(date.getHours())); // 返回日期中的小时数（0到23）
      returnArr.push(this.formatNumber(date.getMinutes())); // 返回日期中的分钟数（0到59）
      returnArr.push(this.formatNumber(date.getSeconds())); // 返回日期中的秒数（0到59）

      for (const i in returnArr) {
        // 判断对象是否含有某个非继承属性
        if ({}.hasOwnProperty.call(returnArr, i)) {
          format = format.replace(formateArr[i], returnArr[i]); // 替换
        }
      }
      return format;
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : `0${n}`;
    },
  }
}
</script>
